import "./Header.css";
import ViewNotification from "./ViewNotification";
import UserInformation from "./UserInformation";
import { BoxFlex } from "../../components/Boxes";
import { useAuth } from "../../contexts/AuthContext";
import { NavLink, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useReadQueue } from "../../contexts/ReadQueueContext";

const Header = (props) => {
  const { menu, setMenu } = props;
  const { pendingCount } = useReadQueue();
  const [showQueue, setShowQueue] = useState(false);

  return (
    <div className="h-[110px] flex flex-col justify-between bg-[#1c3144] sm:bg-gradient-to-r from-[#1c3144] to-[#0B3C5D]">
      <div className="flex justify-between">
        <button
          onClick={() => setMenu(!menu)}
          className="hidden text-2xl px-4 portrait:block"
        >
          <i className="fas fa-angle-double-right"></i>
        </button>
        <div className=""></div>
        <div className="flex justify-between items-center gap-2 px-4 pt-2">
          <div className="relative">
            <button
              onClick={() => setShowQueue((prev) => !prev)}
              className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-2 text-white"
            >
              <i className="fa-solid fa-file-import"></i>
              <span>Pendientes</span>
              {pendingCount > 0 ? (
                <span className="rounded-full bg-[#ffc700] px-2 py-0.5 text-xs font-semibold text-[#1c3144]">
                  {pendingCount}
                </span>
              ) : null}
            </button>
            {showQueue ? <ReadQueuePanel /> : null}
          </div>
          {/* <ViewNotification /> */}
          <UserInformation />
        </div>
      </div>
      <TabsContainer />
    </div>
  );
};

const TabsContainer = () => {
  const { user, setUser } = useAuth();
  const { rolId } = useParams();
  useEffect(() => {
    setUser(user);
  }, []);

  return (
    <div className="">
      <nav className="flex overflow-auto">
        {user?.rols?.map((rol) => {
          const isActive = parseInt(rolId) === rol.id;
          return (
            <NavLink
              to={`/rol/${rol.id}/menu`}
              key={rol.id}
              className={
                isActive
                  ? "drop-shadow-md duration-200 cursor-pointer font-semibold bg-white rounded-t-[15px] py-[5px] px-[10px] flex w-auto items-center justify-center  text-lg lg:text-xl text-black"
                  : "drop-shadow-md duration-200 cursor-pointer bg-[#ffffff]/20 shadow-[0_0_4px_rgba(0,0,0,0.25)] rounded-t-[15px] py-[5px] px-[5px] sm:px-[10px] flex w-auto items-center justify-center text-lg lg:text-xl text-[white]"
              }
            >
              <FontAwesomeIcon
                icon={`${rol.icon ? rol.icon : "fa-solid fa-user-pen"}`}
                className={`'mr-1'${
                  isActive ? "fill-black mr-4" : "fill-[#ffffff] mr-1"
                }`}
              />
              <span className="min-w-fit">{rol.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

const ReadQueuePanel = () => {
  const { queue, pendingCount, clearCompleted } = useReadQueue();
  const hasVisibleItems = queue.some(
    (item) => item.status === "pending" || item.status === "running" || item.status === "error"
  );

  return (
    <div className="absolute right-0 top-[48px] z-50 min-w-[320px] max-w-[360px] rounded-xl border border-slate-200 bg-white p-3 shadow-xl">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-800">Procesos pendientes</h3>
        {queue.length > 0 ? (
          <button onClick={clearCompleted} className="text-xs text-blue-600">
            Limpiar completados
          </button>
        ) : null}
      </div>
      {!hasVisibleItems ? (
        <p className="text-sm text-slate-500">No hay documentos pendientes.</p>
      ) : (
        <ul className="max-h-[260px] space-y-2 overflow-auto">
          {queue.map((item) => (
            <li key={item.id} className="rounded-lg border border-slate-200 p-2 text-sm">
              <div className="font-medium text-slate-700">{item.field?.label || item.field?.name || "Documento"}</div>
              <div className="text-xs text-slate-500">
                Estado: {item.status === "pending" ? "Pendiente" : item.status === "running" ? "Procesando" : item.status === "error" ? "Error" : "Completado"}
              </div>
              {item.errorMessage ? <div className="mt-1 text-xs text-red-600">{item.errorMessage}</div> : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Header;
